import axios from "../../config/axiosConfig";
import {
  CREATE_PURCHASE_CHALLAN_RETURN, DELETE_PURCHASE_CHALLAN_RETURN,
  GET_PURCHASE_CHALLAN_RETURNS,
  PURCHASE_CHALLAN_RETURN_REQUEST,
  PURCHASE_CHALLAN_RETURN_REQUEST_SUCCESS,
  GET_PURCHASE_CHALLAN_RETURNS_PAGE,
  PURCHASE_CHALLAN_RETURN_REQUEST_FAILURE,
  UPDATE_PURCHASE_CHALLAN_RETURN,
  SET_PURCHASE_CHALLAN_RETURN_ORDERS
} from "../types/purchase-challan-return-types";

export const getPurchaseChallanReturnsWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_CHALLAN_RETURN_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Book_Id,Account_Id,Lot_Id'
      };
      return axios.get("/purchase-challan-return/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PURCHASE_CHALLAN_RETURNS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getPurchaseChallanReturns = (commonMaster, include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_CHALLAN_RETURN_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/purchase-challan-return/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PURCHASE_CHALLAN_RETURNS, payload: response.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getPurchaseChallanReturnById = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: PURCHASE_CHALLAN_RETURN_REQUEST });
    
      return axios.get(`/purchase-challan-return/get/${id}`).then((response) => {
        dispatch({ type: PURCHASE_CHALLAN_RETURN_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createPurchaseChallanReturn = (purchasebill) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: PURCHASE_CHALLAN_RETURN_REQUEST });
      const newPurchaseChallanReturn = {
        ...purchasebill
      };
      return axios.post("/purchase-challan-return/add", newPurchaseChallanReturn,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_PURCHASE_CHALLAN_RETURN, payload: response.data });
        } else {
          dispatch({
            type: PURCHASE_CHALLAN_RETURN_REQUEST_FAILURE,
            error: "Purchase Challan Return create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updatePurchaseChallanReturn = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_CHALLAN_RETURN_REQUEST });
      const { auth } = getState();
      return axios.put("/purchase-challan-return/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_PURCHASE_CHALLAN_RETURN,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: PURCHASE_CHALLAN_RETURN_REQUEST_FAILURE,
            error: "Purchase Challan Return update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deletePurchaseChallanReturn = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_CHALLAN_RETURN_REQUEST });
      return axios.delete(`/purchase-challan-return/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_PURCHASE_CHALLAN_RETURN, id: id });
          const include = ['id', 'Entry_No', 'Challan_No', 'Book_Id', 'Date', 'Account_Id', 'Order_No', 'Bill_Date', 'Lot_Id', 'Amount', 'Net_Total'].join(',');
          const searchCols = ['Entry_No', 'Challan_No'].join(',');
          const { transaction: { purchaseChallanReturn: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getPurchaseChallanReturnsWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getPurchaseChallanReturnOrders = (id, bookId) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        // finyearId: auth.finyear?.id,
        // companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        bookId,
        id
      };
      console.log('>>>>>common order', auth?.company?.Common_Order);
      if (!auth?.company?.Common_Order) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get(`/purchase-challan-return/getRemainingPurchaseOrders`, { params }).then((response) => {
        dispatch({
            type: SET_PURCHASE_CHALLAN_RETURN_ORDERS,
            payload: response.data || [],
        });
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_CHALLAN_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};